import { render, staticRenderFns } from "./SummaryCard.vue?vue&type=template&id=65159644&scoped=true&"
import script from "./SummaryCard.vue?vue&type=script&lang=ts&"
export * from "./SummaryCard.vue?vue&type=script&lang=ts&"
import style0 from "./SummaryCard.vue?vue&type=style&index=0&id=65159644&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65159644",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/ypoli/Works/od-supplies-app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VChip } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VFooter } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileAvatar } from 'vuetify/lib'
import { VListTileContent } from 'vuetify/lib'
import { VListTileTitle } from 'vuetify/lib'
installComponents(component, {VCard,VCardActions,VCardText,VCardTitle,VChip,VDivider,VFlex,VFooter,VImg,VLayout,VListTile,VListTileAvatar,VListTileContent,VListTileTitle})
